module.exports = __webpack_public_path__ + "img/light.2aca0d9b.png";